
<div class="pr-0" >
    <v-expansion-panels
        v-if    = "customer"
        v-model = "expand"
        class   = "customer-list"
        :style  = "'max-height:' + (height-10) + 'px'"

        accordion
        flat
    >
        <v-expansion-panel
            class = "pa-0 pr-1"
            v-for = "(item, index) in customer"
            :key  = "item.id"
        >
            <v-expansion-panel-header
                :ripple     = "false"
                expand-icon = ""
                class       = "pa-0"
                hide-actions
            >
                <p-dms-treeview-customer
                    :customer = "item"
                    :count    = "unitCount"
                    :selected = "expand && expand === index"
                    @filter   = "onFilter"
                />
            </v-expansion-panel-header>

            <v-expansion-panel-content
                class="customer-content"
            >
                <p-dms-treeview-unit-list
                    class     = "ml-12"
                    :customer = "item"
                    :show-filter = "unitFilter"
                    style     = "width: calc(100% - 44px)"
                    @site     = "onSite"
                    @selected = "onSelected"
                    @units    = "onUnits"
                />
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</div>
